export default __webpack_public_path__ + "static/media/login_logo.6f238268.svg";